import { render } from "./Orders.vue?vue&type=template&id=ac765252"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
script.render = render

export default script